import React, { useState } from 'react';
import { TextField } from '@mui/material';

import { TextOperationService } from '../../../services';
import {
  DEFAULT_RESTRUCTURE_TEXT_STATE,
  buildRestructureTextRequest,
  type RestructureTextFormState,
} from './buildRequests';
import { useRunTextOperation } from './useTextOperationMutation';
import { TEXT_OPERATION_CATALOG } from './operationCatalog';
import { PanelScaffold } from './PanelScaffold';
import type { TextPanelProps } from './panelProps';

export const RestructurePanel: React.FC<TextPanelProps> = ({
  ensureSession,
  isCreatingSession = false,
  documentId,
  sectionId,
  onResult,
}) => {
  const [state, setState] = useState<RestructureTextFormState>(DEFAULT_RESTRUCTURE_TEXT_STATE);
  const { run, mutation, validationError } = useRunTextOperation(
    TextOperationService.restructure,
    ensureSession,
    documentId,
    { onResult },
  );

  const needsDocument = !documentId;
  const handleSubmit = () => run((sid, docId) => buildRestructureTextRequest(state, sid, docId, sectionId));

  return (
    <PanelScaffold
      meta={TEXT_OPERATION_CATALOG.Restructure}
      needsDocument={needsDocument}
      validationError={validationError}
      mutationError={mutation.isError ? mutation.error : null}
      busy={mutation.isPending}
      starting={isCreatingSession}
      submitDisabled={mutation.isPending || isCreatingSession || needsDocument}
      submitLabel="Restructure"
      busyLabel="Restructuring…"
      onSubmit={handleSubmit}
    >
      <TextField
        label="Structure hint (optional)"
        value={state.structureHint}
        onChange={e => setState(s => ({ ...s, structureHint: e.target.value }))}
        size="small"
        fullWidth
        multiline
        minRows={1}
        maxRows={3}
        placeholder="e.g. lead with the conclusion, then supporting points"
      />
    </PanelScaffold>
  );
};
